import React from 'react';
import { Container, Header, Icon, Segment } from 'semantic-ui-react';


function ShowInfoTestPlayer({ fullView }) {
  return (
    <Container textAlign='center' >
      <Segment basic >
        <Header as='h4' icon>
          <Icon name='user secret' />
          KONTO TESTOWE
          <Header.Subheader style={{ fontSize: 13 }}>
            Chcielibyśmy serdecznie zaprosić Cię do wypróbowania potencjału naszej aplikacji już teraz, bez procesu rejestracji! <br/>
            <br/>
            Użyj przycisku <b>SKORZYSTAJ Z KONTA DEMO</b> aby uzyskać pełnoprawny dostęp do generatora turniejów. Oferuje on wszystkie możliwości aplikacji w najwyższym pakiecie złotym. Uwaga: wszelkie operacje na koncie demo są kasowane po <b>1 godzinie</b>.
            <br/><br/>
            Nie zwlekaj dłużej! Zaloguj się teraz i zacznij eksplorować wszystkie możliwości, jakie oferuje nasza aplikacja generatora turniejów online.
             Jesteśmy przekonani, że zakochasz się w tym narzędziu od pierwszego użycia!

            {fullView ? <>
              Dlaczego warto wypróbować naszą aplikację? Oto kilka powodów:<br /><br />

              <b>1.Pełna funkcjonalność:</b> Nawet na koncie testowym masz dostęp do wszystkich funkcji naszego generatora turniejów. Możesz tworzyć, dostosowywać i monitorować swoje turnieje.
              <br />
              <b>2.Bez ryzyka:</b> Korzystając z naszego konta testowego, nie ponosisz żadnych kosztów. To doskonały sposób na zapoznanie się z naszym narzędziem bez zobowiązań.
              <br />
              <b>3.Szybki start:</b> Zalogowanie się zajmuje tylko chwilę, a nasza aplikacja jest intuicyjna i łatwa w obsłudze.
              <br />
              <b>4.Wsparcie techniczne:</b> Jeśli napotkasz jakiekolwiek pytania lub problemy, nasz zespół wsparcia technicznego jest gotów pomóc.
              <br />
              <b>5.Sprawdź, czy spełniamy Twoje potrzeby:</b> Dzięki temu darmowemu dostępowi możesz ocenić, czy nasza aplikacja jest tym, czego szukasz do organizacji turniejów.
              <br /><br />
            </> : ""}
          </Header.Subheader>
        </Header>
      </Segment>
    </Container>
  )
}

export default ShowInfoTestPlayer;